import baseConfig from './production';
import ssrConfig from './ssr';

const customConfig = () => {
  switch (process.env.NODE_ENV) {
    case 'development':
      return require('./development');
    case 'uat':
      return require('./uat');
    case 'qa':
      return require('./qa');
    case 'tl':
      return require('./tl');
    case 'deveks':
      return require('./devEks');
    default:
      return {};
  }
};

export default { ...baseConfig, ...customConfig(), ...ssrConfig };



// WEBPACK FOOTER //
// ./server/config/index.js